/* src/app/modules/shared/components/header-column/header-column-badge/header-column-badge.component.scss */
app-header-column-badge {
  display: contents;
}
/*# sourceMappingURL=header-column-badge.component.css.map */
